import React from 'react'
import './styles.css'
import classnames from 'classnames'

export function AdhesiveTapeImage({src, alt, className}) {
  return (
    <div className={classnames('adhesive-wrapper', className)}>
      <div className='adhesive-container'>
        <img className="adhesive-image" src={src} alt={alt} />
        <img className='adhesive-tape-rt' src="/images/elements/tape1.png" alt="adhesive tape" />
        <img className='adhesive-tape-lb' src="/images/elements/tape1.png" alt="adhesive tape" />
        <span className='adhesive-skeleton' />
      </div>
    </div>
  )
}
